import { Component, OnInit } from '@angular/core';
import { debounce } from 'lodash';

import { environment } from '../../../environments/environment';
import {
    NavigationApp,
    NavigationPage,
    NavigationCategory,
} from '../../helpers/navigation';
import { SearchResults } from '../../helpers/search';

import { AuthService } from '../../services/auth.service';
import { DocsService } from '../../services/docs.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
    selector: 'kd-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

    private debouncedSearch: () => void = debounce(this.search, environment.debounceInput);
    isOpen = false;
    isStaff: boolean;
    navigation: Array<NavigationApp>;
    query = '';
    results: SearchResults;

    constructor(
        private authService: AuthService,
        private docsService: DocsService,
        private navigationService: NavigationService,
    ) { }

    ngOnInit() {
        this.navigation = this.docsService.getNavigation();
        if (this.authService.isAuthorized()) {
            this.isStaff = this.authService.getAccount().is_staff;
        }

        this.navigationService.onMenuState().subscribe((open: boolean) => {
            this.isOpen = open;
        });

        this.navigationService.onNavigation().subscribe(() => {
            this.closeMenu();
        });

        this.docsService.getSearch().subscribe((results: SearchResults) => {
            if (results.query === this.query) {
                this.results = results;
            }
        });
    }

    clearSearch(): void {
        this.query = '';
        this.results = null;
    }

    closeMenu(): void {
        this.clearSearch();
        this.navigationService.closeMenu();
    }

    getFirstPageLink(app: NavigationApp): string {
        if (!app.categories || !app.categories.length) {
            return null;
        }

        const category: NavigationCategory = app.categories[0];

        if (!category.pages || !category.pages.length) {
            return null;
        }

        const page: NavigationPage = category.pages[0];

        return `/${app.slug}/${category.slug}/${page.slug}`;
    }

    getPages(category: NavigationCategory): Array<NavigationPage> {
        const result: Array<NavigationPage> = [];

        for (const page of category.pages) {
            if (page.is_public || this.isStaff) {
                result.push(page);
            }
        }

        return result;
    }

    isAppActive(app: NavigationApp): boolean {
        return environment.useExpandedNavigation || this.navigationService.isAppRoute(app.slug);
    }

    onSearch(): void {
        this.results = null;
        this.debouncedSearch();
    }

    onSearchKey(event: KeyboardEvent): void {
        switch (event.key) {
        case 'Escape':
        case 'Tab':
            this.clearSearch();
            break;
        }
    }

    private async search(): Promise<void> {
        await this.docsService.search(this.query);
    }

    async toggleVisibility(event: Event, page: NavigationPage): Promise<void> {
        event.preventDefault();
        event.stopPropagation();

        if (this.isStaff) {
            page.is_public = await this.docsService.toggleVisibility(page.id, page.is_public);
        }
    }
}
